import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-xl font-medium"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Temaer for forløb: ", -1)
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericTable = _resolveComponent("GenericTable")!
  const _component_CourseThemeSessionsModal = _resolveComponent("CourseThemeSessionsModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "close-button": "",
    size: "w-240",
    padding: "px-10 py-6"
  }, {
    toggle: _withCtx((state) => [
      _renderSlot(_ctx.$slots, "toggle", _normalizeProps(_guardReactiveProps(state)))
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.selectedCourse)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.selectedCourse?.title)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedCourse.title), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_GenericTable, {
                "clickable-rows": "",
                headers: _ctx.headers,
                items: _ctx.items,
                onItemClicked: _ctx.onThemeClicked
              }, null, 8, ["headers", "items", "onItemClicked"]),
              _createVNode(_component_CourseThemeSessionsModal, {
                "selected-theme-id": _ctx.selectedThemeId,
                "selected-course": _ctx.selectedCourse
              }, {
                toggle: _withCtx(({ open }) => [
                  _createElementVNode("input", {
                    ref: "modal-input",
                    class: "hidden",
                    type: "hidden",
                    onClick: open
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["selected-theme-id", "selected-course"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}